import { render, staticRenderFns } from "./V2FormViewer.vue?vue&type=template&id=3dc2ffe0&scoped=true&"
import script from "./V2FormViewer.vue?vue&type=script&lang=ts&"
export * from "./V2FormViewer.vue?vue&type=script&lang=ts&"
import style0 from "./V2FormViewer.vue?vue&type=style&index=0&id=3dc2ffe0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2ffe0",
  null
  
)

export default component.exports